<!-- Filters / Selection bar and view mode selector -->
<div class="mb-4 ">
  @if (selectedItems.length > 0) {
    <!-- Contextual selection bar -->
    <div
      class="flex items-center justify-between rounded-lg bg-primary-50 px-4 py-3"
    >
      <div class="flex items-center gap-2">
        <i class="pi pi-check-circle text-primary-600"></i>
        <span class="font-medium text-primary-700">
          {{ selectedItems.length }}
          {{ "travelBoards.selectedCount" | transloco }}
        </span>
      </div>
      <div class="flex items-center gap-2">
        @if (hasUnverifiedSelection) {
          <p-button
            type="button"
            icon="pi pi-check-circle"
            (click)="markSelectedVerified()"
            severity="warn"
            [outlined]="true"
            size="small"
            [label]="'travelBoards.verifySelectedItems' | transloco"
          />
        }
        <p-button
          type="button"
          icon="pi pi-sync"
          (click)="recalculateSelectedTrips()"
          [outlined]="true"
          size="small"
          [label]="'travelBoards.recalculateSelectedItems' | transloco"
        />
        <p-button
          type="button"
          icon="pi pi-trash"
          (click)="deleteSelectedTrips()"
          severity="danger"
          [outlined]="true"
          size="small"
          [label]="'travelBoards.deleteSelectedItems' | transloco"
        />
        <p-button
          type="button"
          icon="pi pi-times"
          (click)="clearSelection()"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          size="small"
          [pTooltip]="'travelBoards.clearSelection' | transloco"
          tooltipPosition="top"
        />
      </div>
    </div>
  } @else {
    <!-- Normal filters bar -->
    <div class="flex items-end justify-between gap-4">
      <app-filter-trips
        (searchChange)="onSearchChange($event)"
        (filterChange)="onFilterChange($event)"
      />
      <div class="flex items-end gap-2">
        @if (isInTableMode) {
          <app-table-settings />
        }
        <p-selectbutton
          [options]="viewModeOptions"
          [(ngModel)]="isInTableMode"
          (onChange)="onModeChange()"
          aria-label="Switch between grid view and table view"
          size="small"
        >
          <ng-template let-item pTemplate="item">
            <i [class]="item.icon"></i>
          </ng-template>
        </p-selectbutton>
      </div>
    </div>
  }
</div>

<!-- Table or Grid -->
<div class="w-full">
  @if (isInTableMode) {
    <app-table-view
      [filteredTrips]="travelBoardService.filteredData()"
      (selectionChange)="onSelectionChange($event)"
      (pageChange)="onPaginationChange($event)"
    />
  } @else {
    <app-grid-view
      [filteredTrips]="travelBoardService.filteredData()"
      (pageChange)="onPaginationChange($event)"
    />
  }
</div>
